function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M166.5,432.8c169.8,0,262.7-140.7,262.7-262.7c0-4,0-8-0.3-11.9c18.1-13.1,33.7-29.3,46.1-47.8c-16.9,7.5-34.7,12.4-53,14.5 c19.3-11.5,33.7-29.7,40.6-51.1c-18.1,10.8-38,18.3-58.6,22.4c-35-37.2-93.4-39-130.6-4c-24,22.5-34.2,56.2-26.7,88.2 c-74.2-3.7-143.4-38.8-190.3-96.5c-24.5,42.2-12,96.2,28.6,123.2c-14.7-0.4-29.1-4.4-41.9-11.6c0,0.4,0,0.8,0,1.2 c0,43.9,31,81.8,74.1,90.5c-13.6,3.7-27.9,4.2-41.7,1.6c12.1,37.6,46.8,63.4,86.3,64.1c-32.7,25.7-73.1,39.6-114.7,39.6 c-7.3,0-14.7-0.5-22-1.3C67.2,418.4,116.3,432.8,166.5,432.8"
});

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8f325d01.svg";
export { ForwardRef as ReactComponent };